import { render, staticRenderFns } from "./ProvisionsTable.vue?vue&type=template&id=6b6d16ec&"
import script from "./ProvisionsTable.vue?vue&type=script&lang=js&"
export * from "./ProvisionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports